'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var colors = {
  primaries: {
    '00': '#ECE4F6',
    '01': '#E1D5F1',
    '02': '#C5AFE4',
    '03': '#A989D7',
    '04': '#8D63CA',
    '05': '#00C684',
    '06': '#7140BA',
    '07': '#6639A7',
    '08': '#5A3394',
    '09': '#4F2C81',
    10: '#44266E' // '01': '#F8F7FC', // page background
    // '03': '#EBE4F6', // active bg
    // '02': '#B8A3D7', // form elements active state and base

  },
  green: {
    '00': '#E5F9F3',
    '01': '#B2EEDA',
    '02': '#80E3C2',
    '03': '#4CD7A9',
    '04': '#26CF96',
    '05': '#00C684',
    '06': '#00B277',
    '07': '#009E6A',
    '08': '#008B5C',
    '09': '#00774F',
    10: '#006342'
  },
  red: {
    '00': '#FDECEF',
    '01': '#FAC7CE',
    '02': '#F7A1AE',
    '03': '#F47B8E',
    '04': '#F15F75',
    '05': '#EF435D',
    '06': '#D73C54',
    '07': '#BF364A',
    '08': '#A72F41',
    '09': '#8F2838',
    10: '#78212E'
  },
  yellow: {
    '00': '#FFFAEB',
    '01': '#FFEFC2',
    '02': '#FFE499',
    '03': '#FFD970',
    '04': '#FFD152',
    '05': '#FFC933',
    '06': '#E5B52E',
    '07': '#CCA129',
    '08': '#B38D24',
    '09': '#99791F',
    10: '#806519'
  },
  grey: {
    '00': '#F7F7F7',
    // chip bg
    '01': '#E5E5E5',
    // borders
    '02': '#D4D4D4',
    // inactive state
    '03': '#C3C3C3',
    // icons
    '04': '#B7B7B7',
    '05': '#AAAAAA',
    '06': '#999999',
    '07': '#888888',
    // inactive text
    '08': '#777777',
    // secondary text color
    '09': '#666666',
    10: '#555555',
    11: '#444444',
    12: '#333333' // default text color

  },
  black: '#000000',
  white: '#FFFFFF',
  nonConformist: {
    activeBg: '#E5F9F3' // item hover / active background

  },

  get primary() {
    return this.primaries['05'];
  }

};

exports.default = colors;
